<template>
  <footer class="pt-16 pb-8 mt-auto border-t border-gray-200 bg-gray-50">
    <div class="px-5 mx-auto max-w-7xl">
      <!-- Main Grid -->
      <div class="grid grid-cols-1 gap-12 mb-16 md:grid-cols-2 lg:grid-cols-4">
        <!-- Column 1: Brand & Social -->
        <div class="space-y-6">
          <router-link to="/">
            <img src="/img/logo.webp" class="w-52 md:w-64" :alt="$GetColumn('brand_name')" />
          </router-link>
          <p class="text-sm leading-relaxed text-gray-500">
            致力於提供極簡、舒適且具有設計感的生活選物，為您的日常增添不凡質感。
          </p>
          <!-- Social Icons -->
          <div class="flex gap-4">
            <a :href="$GetColumn('company_facebook')" target="_blank"
              class="flex items-center justify-center w-10 h-10 text-gray-400 transition-all bg-white border border-gray-200 rounded-full hover:text-black hover:border-black">
              <!-- Facebook Icon -->
              <i class="icon-facebook"></i>
            </a>
            <a :href="$GetColumn('company_instagram')" target="_blank"
              class="flex items-center justify-center w-10 h-10 text-gray-400 transition-all bg-white border border-gray-200 rounded-full hover:text-black hover:border-black">
              <!-- Instagram Icon -->
              <i class="icon-instagram"></i>
            </a>
            <a :href="$GetColumn('company_line')" target="_blank"
              class="flex items-center justify-center w-10 h-10 text-gray-400 transition-all bg-white border border-gray-200 rounded-full hover:text-black hover:border-black">
              <!-- LINE Icon -->
              <i class="icon-line"></i>
            </a>
          </div>
        </div>

        <!-- Column 2: Sitemap -->
        <div>
          <h3 class="mb-6 text-sm font-bold tracking-wider text-gray-900 uppercase">
            網站地圖
          </h3>
          <ul class="space-y-3">
            <li v-for="(item, item_index) in menu_list" :key="`menu_item_${item_index}`">
              <router-link :to="item.link" class="text-sm text-gray-500 transition-colors hover:text-black">
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Column 3: Policies -->
        <div>
          <h3 class="mb-6 text-sm font-bold tracking-wider text-gray-900 uppercase">
            條款與規範
          </h3>
          <ul class="space-y-3">
            <li>
              <router-link to="/terms/terms_of_customer"
                class="text-sm text-gray-500 transition-colors hover:text-black">服務條款</router-link>
            </li>
            <li>
              <router-link to="/terms/site_privacy"
                class="text-sm text-gray-500 transition-colors hover:text-black">隱私權政策</router-link>
            </li>
            <li>
              <router-link to="/terms/return_policy"
                class="text-sm text-gray-500 transition-colors hover:text-black">退換貨政策</router-link>
            </li>
          </ul>
        </div>

        <!-- Column 4: Contact Info -->
        <div>
          <h3 class="mb-6 text-sm font-bold tracking-wider text-gray-900 uppercase">
            聯絡資訊
          </h3>
          <ul class="space-y-4 text-sm text-gray-500">
            <li class="flex items-start gap-3">
              <span class="font-medium text-gray-900 min-w-[4rem]">公司名稱</span>
              <span>
                {{ $GetColumn("company_name") }}
              </span>
            </li>
            <li class="flex items-start gap-3">
              <span class="font-medium text-gray-900 min-w-[4rem]">統一編號</span>
              <span class="font-mono">
                {{ $GetColumn("company_code") }}
              </span>
            </li>
            <li class="flex items-start gap-3">
              <span class="font-medium text-gray-900 min-w-[4rem]">公司地址</span>
              <span>{{ $GetColumn("company_address") }}</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="font-medium text-gray-900 min-w-[4rem]">聯絡電話</span>
              <span class="font-mono">{{ $GetColumn("company_phone") }}</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="font-medium text-gray-900 min-w-[4rem]">電子信箱</span>
              <span>{{ $GetColumn("company_email") }}</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="font-medium text-gray-900 min-w-[4rem]">營業時間</span>
              <span class="font-mono">{{ $GetColumn("company_time") }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Copyright -->
      <div
        class="flex flex-col items-center justify-between gap-4 pt-8 text-xs text-gray-400 border-t border-gray-200 md:flex-row">
        <p>&copy; {{ new Date().getFullYear() }} 快樂買購物商城版權所有</p>
        <p>
          DESIGN BY
          <a href="https://www.yongxin-design.com" target="_blank">泳欣事業有限公司</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  data() {
    return {
      menu_list: [
        {
          title: "商品列表",
          sub_title: "Products",
          link: "/collections",
        },
        {
          title: "關於我們",
          sub_title: "About Us",
          link: "/about",
        },
        {
          title: "最新消息",
          sub_title: "News",
          link: "/news",
        },
        {
          title: "聯絡我們",
          sub_title: "Contact",
          link: "/contact",
        },
        {
          title: "非會員查詢訂單",
          sub_title: "OrderSearch",
          link: "/order_search/search",
        },
      ],
    };
  },
  methods: {
    ScrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>
